<template>
	<div id="usre-baseinfor" class="oh" v-title :data-title="title">
		<!-- 政府端 -->
		<leftnav class="fl" mkcode="E" itemcode="E-WDGXW"></leftnav>
		<div class="index_left" :style="isCollapse?'margin-left: 0;width:100%':''" >
			<govheader :show-video="true" :video-type="5"></govheader>
			<div class="index_left_centerpage"> 
			<div class="whitebox right_topbox" style="min-height: 800px;">
				<div class="right_boxtitle">
					<span class="fl right_title">我的关系网</span>  
					<vedioTips :type="8" class="pt-1 pl-10 ml-3"></vedioTips>
				</div>
					<div class="userrelation">
							<div class="titlebox">
								<h5 class="title fl flbox">我熟悉的企业</h5><h5 class="title fl flbox">我想联系的企业</h5><h5 class="fl flbox1 title tac">计算结果</h5>
							</div>
							<div class="oh" v-for="list in relationlist">
								<div class="fl flbox">
									<span class="fl" v-for="item in list.sourceEnterprise" :data-d="item.id" @click="routerlinkid('/enterprises',item.stockCode)">{{item.title}}</span>
								</div>
								<div class="fl flbox">
									<span class="fl"   :data-d="list.targetEnterprise.id" @click="routerlinkid('/enterprises',list.targetEnterprise.stockCode)">{{list.targetEnterprise.title}}</span>
								</div>
								<div class="fl flbox1 tac"><span class="curp" @click="routerlinkid('/calculatorresult',list.id)">查看结果</span></div>
							</div>
					</div>
			</div>
			</div>
		</div>
	</div>
</template> 
<script>
import { mapState, mapMutations, mapGetters } from "vuex";

	export default {
	  name: 'userRelational',
	  computed: {
		...mapState({
			isCollapse: (state) => state.isCollapse,
		}),
		...mapGetters(['isCollapse'])
	},
	  data(){return{
				userdata:{}, 
				title:'我的关系网', 
			relationlist:[],
			}},
		 created() {
		 	this.userdata=this.getuseriformation(); 
		 },
			mounted() { 
			this.bus.$emit('loading', true);
				this.getlist();
			},
			methods:{  
				getlist(){
					var _this=this;
					this.$axios.get(this.$api.cyl.enterpriseRelation.list()+'?page=1', {headers: {AuthToken: this.userdata.token}
					}).then(function(res) {
						if(res.data.success){
						console.log('关系列表', res.data.list); 
						_this.relationlist=res.data.list;
							_this.bus.$emit('loading', false);
						} else {
							
						}
					}).catch(function(error) {console.log(error)});
				},
				
				
				
			}
	}  
</script>

<style>
	
</style>
